module.exports = __webpack_public_path__ + "img/adv-bird-1.25ac2224.png";